export default {
  init: 'Send Code',
  end: 'Resend',
  toofast: 'Sending verification code too frequently, please try again later'
}
